import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2706877171/src/football-trends-face/src/app/[locale]/bets/advises/components/betAdvisesList.tsx");
